<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2025-07-11 10:54:11
!-->
<template>
  <div id="index" class="index">
    <!-- 外层容器控制位置，可根据需求调整 -->
    <div class="bubble-container" v-if="isShow">
      <!-- 气泡内容 -->
      <div class="bubble-tip">
        <span v-html="isNewYear ? tipTextNewYear : tipText"></span>
        <!-- 关闭按钮 -->
        <div class="close-btn" @click="handleClose"></div>
      </div>
    </div>
    <div class="startGuide"  @mouseenter="MoveIn()"
          @mouseleave="Remove()">
      <!-- <ByTooltip placement="left"> -->
      <!-- <img src="../../../../static/newStatic/img/guide/base.png" width="48" height="48"  @mouseenter="()=>{isShow = false;showcard=true}"> -->
      <SvgaHoverImage
        :staticImage="
          require('../../../../static/newStatic/img/guide/base.png')
        "
        :svgaSrc="svgaUrl"
        :svgaSrc2="svgaUrl2"
        altText="示例图片"
        width="40px"
        height="40px"
        :loop="false"
        :triggerPlay="isHover"
        :triggerPlay1="isHover1"
        :several="several"
      ></SvgaHoverImage>
      <template>
        <div
        class="main-all"
        v-if="showcard"
      >
        <div class="main main-0" v-if="isIndexAndCheckPage">
          <div class="tip-1">
            <span class="left">小运猜测你需要【{{typeString[this.typePage]}}-下单】指引？</span>
            <!-- <span class="right"
              ><i
                class="el-icon-close"
                @click="
                  () => {
                    isTip = false;
                    isShow = true;
                  }
                "
              ></i
            ></span> -->
          </div>
          <div class="tip-2">
            
            <div>
              <span>快点击下方按钮开始吧～</span><br/>
              <span>在此期间你可以随时退出指引。</span>
            </div>
          </div>
          <div class="tip-3-0 flex-center" @click="startGuidance()">
            <span>开始指引</span>
          </div>
          <div class="tip-4-0">
            <span @click="drawer = true">查看其他指引</span>
          </div>
          <img
            src="../../../../static/newStatic/img/guide/pic_youxia@2x.png"
            width="96"
            height="96"
          />
        </div>

        <div
          class="main main-1" 
          v-if="this.$route.path == '/customerCenter'"
        >
          <div class="tip-1">
            <span>小运猜测你需要【工作台】以下指引？</span>
          </div>
          <div class="tip-2">
            <span>快选择并点击下方按钮开始吧～</span><br />
            <span>在此期间你可以随时退出指引。</span>
          </div>
          <div class="tip-3">
            <button
              class="tip-3-1 flex-center"
              @click.stop="startGuidance('select')"
            >
              <span>查价指引</span>
            </button>
            <button
              class="tip-3-1 flex-center"
              @click="startGuidance('module')"
            >
              <span>板块介绍</span>
            </button>
          </div>
          <div class="tip-4">
            <span
              @click="
                drawer = true;
                showcard = false;
              "
              >查看其他指引</span
            >
          </div>
          <img
            src="../../../../static/newStatic/img/guide/pic_youxia@2x.png"
            width="96"
            height="96"
          />
        </div>
        </div>
      </template>
      <!-- </ByTooltip> -->
    </div>
    <el-drawer
      title="百运网使用教程"
      :visible.sync="drawer"
      :with-header="false"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :wrapper-closable="false"
    >
      <SideNav @close="handleDrawerClose"></SideNav>
    </el-drawer>
  </div>
</template>

<script>
import SvgaHoverImage from "./SvgaHoverImage.vue";
import SideNav from "./SideNav.vue";
export default {
  props: {
    // 父辈向子辈传参
  },
  components: {
    // 组件的引用
    SvgaHoverImage,
    SideNav,
  },
  name: "index",
  data() {
    return {
      isShow: true,
      isClose:false,
      showcard: false,
      tipTextNewYear:   `小运祝您新春快乐～</br>如需指引，随时来此处找小运～`,
      tipText: "如需指引，随时来此处找小运～",
      drawer: false,
      typeString: {
        express: "国际快递",
        fba: "FBA头程",
        special: "国际专线",
        packet: "小包专线",
        air: "国际空运",
        sea: "海运散货",
        seaFull: "海运整柜",
        '':'',
      },
      isHover: false,
      isHover1: false,
      svgaUrl: "/static/newStatic/img/guide/bot_smile.svga",
      svgaUrl2: "/static/newStatic/img/guide/bot_smile_reverse.svga",
      several: 1, //1:一个动图  2：两个动图
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
    // 判断是否是查价结果页
    isIndexAndCheckPage() {
      console.log("======地址====",this.$route.fullPath,this.$route);
      return [
        "exp/expEdit",
        "air/airOrderEdit",
        "fba/order/orderEdit",
        "sea/seaOrderEdit",
        "seaFull/seaFullOrderEditNew",
        "seaFull/seaFullOrderEdit"
      ].some((item) => this.$route.fullPath.indexOf(item) !== -1);
    },
    typePage(){
      let value = '';
      if(this.$route.path=='/exp/expEdit'){
        value = 'express'
      }
      if(this.$route.path=='/exp/expEdit' && this.$route.query.ChannelOwnerType == '2'){
        value = 'special'
      }
      if(this.$route.path=='/air/airOrderEdit'){
        value = 'air'
      }
      if(this.$route.path=='/fba/order/orderEdit'){
        value = 'fba'
      }
      if(this.$route.path=='/sea/seaOrderEdit'){
        value = 'sea'
      }
      if(this.$route.path=='/seaFull/seaFullOrderEditNew' || this.$route.path=='/seaFull/seaFullOrderEdit'){
        value = 'seaFull'
      }
      return value
    }
  },

  methods: {
    // 方法
    handleDrawerClose() {
      this.drawer = false;
    },
    MoveIn() {
      // Reset isClose flag when user hovers over the element again
      this.isClose = false;
      this.svgaUrl = "/static/newStatic/img/guide/bot_smile.svga",
      this.svgaUrl2 = "/static/newStatic/img/guide/bot_smile_reverse.svga",
      this.several = 2;
      this.isHover = true;
      this.isHover1 = false;
      this.showcard = true;
    },
    Remove() {
      // Reset isClose flag when user moves mouse away after hovering
      this.isClose = false;
      if(!this.isClose){
        this.svgaUrl = "/static/newStatic/img/guide/bot_smile.svga",
        this.svgaUrl2 = "/static/newStatic/img/guide/bot_smile_reverse.svga",
        this.several = 2;
        this.isHover = false;
        this.isHover1 = true;
        this.showcard = false;
      }
    },
    handleClose() {
      (this.svgaUrl = "/static/newStatic/img/guide/bot_standby.svga"),
      (this.several = 1);
      this.isHover = true;
      this.isHover1 = false;
      this.isShow = false; // 点击关闭，隐藏气泡
      this.isClose = true;
    },
    startGuidance(val) {
      this.$store.commit("IS_Guidance",true);
      this.$emit("input", val);
      this.isHover = false;
      // if(val == 'select'){
      //   document.body.style.overflow = 'hidden';
      //   // 可选：部分浏览器需要同时设置html
      //   document.documentElement.style.overflow = 'hidden';
      // }
      // 添加监听（使用全局函数）
      window.addEventListener('wheel', window.handleWheel, { passive: false });
      let title = val == 'select' ? '客户中心-查价指引':'客户中心-板块介绍';
      this.userGuide(document.title,title,true);
    },
    checkFirstEntryToday() {
      // 获取当前日期（格式：YYYY-MM-DD）
      const today = new Date().toISOString().split("T")[0];
      // 从本地存储获取上次访问日期
      const lastVisitDate = localStorage.getItem("lastVisitDate");
      console.log("======今天是记号===", lastVisitDate, today);
      // 判断是否为首次进入
      if (!lastVisitDate || lastVisitDate !== today) {
        this.isShow = true;
        // 更新本地存储的访问日期
        localStorage.setItem("lastVisitDate", today);
        // 触发首次进入的回调
      } else {
        this.isShow = false;
        // 触发非首次进入的回调
      }
    },
  },
  mounted() {
    // 页面进入时加载内容
    this.checkFirstEntryToday();
    window.handleWheel = (e) => {
      e.preventDefault(); // 禁止滚动
    };
  },
  watch: {
    // 监测变化
  },
  beforeDestroy() {
    // 组件销毁时自动清理（保险措施）
    if (window.handleWheel) {
      window.removeEventListener('wheel', window.handleWheel);
      window.handleWheel = null; // 清空全局变量
    }
  }
};
</script>
<style scoped lang='scss'>
@-webkit-keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%; /* 改为右下角作为变换原点 */
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@keyframes fade-up {
  0% {
    /* 初始状态：下方8px位置，完全透明 */
    transform: translateY(8px);
    opacity: 0;
  }
  100% {
    /* 最终状态：原位置，完全显示 */
    transform: translateY(0);
    opacity: 1;
  }
}
@-webkit-keyframes fade-up {
  0% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
.bubble-container {
  width: 222px;
  min-height: 34px;
  background: #333333; //linear-gradient( 270deg, #4B58E5 0%, #206DEA 100%), #333333;
  border-radius: 12px;
  position: absolute;
  // top: -32px;
  bottom: 100%;
  right: 0px;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-animation: scale-up-br .3s ease-out forwards;
  animation: scale-up-br .3s ease-out forwards;
  transition: all .36s;
  box-sizing: border-box;
  .bubble-tip {
    display: flex;
    // align-items: center;
    // justify-content: space-between;
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 13px;
      color: #ffffff;
      line-height: 20px;
    }
    div {
      margin-left: 4px;
      margin-top: 2px;
      width: 16px;
      height: 16px;
      background: url("../../../../static/newStatic/img/guide/ic_close_default@2x.png");
      background-size: 16px 16px;
      &:hover {
        background: url("../../../../static/newStatic/img/guide/ic_close_hover@2x.png");
        background-size: 16px 16px;
      }
    }
  }
  /* 👇 核心：用渐变实现半三角箭头 */
  .bubble-tip::after {
    content: "";
    position: absolute;
    //   bottom: -14px;
    //   left: 20px; /* 箭头位置，可调整 */
    // top: 34px;
    bottom: -6px;
    right: 20px;
    // width: 8px;
    // height: 6px;
    // background: linear-gradient(216deg, #333333 50%, transparent 50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 0 8px; /* 向上、右、下、左的宽度 */
    border-color: #333 transparent transparent transparent; /* 只显示顶部边框颜色 */
  }
}
.startGuide {
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 👇 核心：用渐变实现半三角箭头 */
.main::after {
  content: "";
  position: absolute;
  //   bottom: -14px;
  //   left: 20px; /* 箭头位置，可调整 */
  top: 14px;
  right: 18px;
  width: 9px;
  height: 8px;
  background: linear-gradient(45deg, #4b58e5 50%, transparent 50%);
  border-bottom: 2px solid rgba(255, 255, 255, 0.56);
}
.main-all{
  position: absolute;
  right: 33px;
  top: -2px;
  padding-right: 25px;
  margin-right: -6px;
  -webkit-animation: fade-up .3s ease-in-out;
  animation: fade-up .3s ease-in-out;
}
.main-0 {
  width: 290px;
  height: 185px;
  .tip-1 {
    display: flex;
    justify-content: space-between;
    .right {
      margin-right: 24px;
    }
  }
  .tip-3-0 {
    width: 136px;
    height: 32px;
    background: #ffffff;
    box-shadow: 0px 8px 16px 0px #2153d8;
    border-radius: 8px;
    margin: 16px auto 8px;
    position: relative;
    z-index: 1;
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 13px;
      color: #2153d8;
    }
    &:hover {
      background: #f4f7fc;
    }
    &:active {
      background: #ebf0f9;
    }
  }
  .tip-4-0 {
    width: 136px;
    height: 32px;
    background: rgba(255, 255, 255, 0);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    margin: 8px auto;
    text-align: center;
    line-height: 32px;
    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
    &:active {
      background: rgba(255, 255, 255, 0.16);
    }
  }
}
.main-1 {
  width: 288px;
  height: 184px;
}
.main {
  background: linear-gradient(221deg, #4b58e5 0%, #206dea 100%);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16);
  border: 2px solid rgba(255, 255, 255, 0.56);
  border-radius: 12px;
  .tip-1 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    padding-top: 16px;
    margin-left: 16px;
  }
  .tip-2 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.88);
    line-height: 20px;
    margin-top: 8px;
    margin-left: 16px;
  }
  .tip-3 {
    display: flex;
    justify-content: space-evenly;
    margin: 16px 0 8px;
    position: relative;
    z-index: 1;
    button {
      border: 0;
    }
    .tip-3-1 {
      width: 115px;
      height: 32px;
      background: #ffffff;
      box-shadow: 0px 8px 16px 0px #2153d8;
      border-radius: 8px;
      &:hover {
        background: #f4f7fc;
      }
      &:active {
        background: #ebf0f9;
      }
    }
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 13px;
      color: #2153d8;
    }
  }
  .tip-4 {
    width: 136px;
    height: 32px;
    background: rgba(255, 255, 255, 0);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    margin: 8px auto;
    text-align: center;
    line-height: 32px;
    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
    &:active {
      background: rgba(255, 255, 255, 0.16);
    }
  }
  img {
    position: relative;
    top: -94px;
    left: 190px;
    pointer-events: none;
  }
}
/deep/ .el-drawer__wrapper {
  z-index: 100000 !important;
}
/deep/ .v-modal {
  z-index: 9998 !important;
}
/deep/ 
  .el-drawer{
    width: 360px !important;
  }


</style>


// WEBPACK FOOTER //
// src/components/backstageManagement/guide/index.vue